module.exports = __webpack_public_path__ + "img/db_1.2d52ac68.svg";